import {
    OPEN_DIALOG,
    CLOSE_DIALOG,
    dialogsList
} from './constants';

export const openDialog = (name, data = {}) => ({
    type: OPEN_DIALOG,
    payload: { name, data }
});

export const closeDialog = (name) => ({
    type: CLOSE_DIALOG,
    payload: name
});

export const dialogs = dialogsList;
